import { Notes } from '@mui/icons-material';
import React from 'react';

import { ITaskInfo } from '@/entities/task/model/client';
import { LoadingStageModel } from '@/models/LoadingStageModel';
import { WeeklyWorkLog } from '@/types';

import { FieldRow } from '../FieldRow';
import { TaskDescriptionSection } from '../TaskDescriptionSection';
import { TaskLoading } from '../TaskLoading';
import { ProcessedField } from '../../utils/processFields';

import s from './DetailsContent.module.scss';

type DetailsContentProps = {
  isLoading: boolean;
  log?: WeeklyWorkLog;
  task: ITaskInfo | null;
  timeFields: ProcessedField[];
  generalFields: ProcessedField[];
  loadingStage: LoadingStageModel;
};

export const DetailsContent: React.FC<DetailsContentProps> = ({
  isLoading,
  log,
  task,
  timeFields,
  generalFields,
  loadingStage,
}) => {
  if (isLoading) {
    return <TaskLoading isLoading={true} />;
  }

  return (
    <>
      {timeFields.length > 0 && (
        <div className={s.timeSection}>
          {timeFields.map((item) => (
            <FieldRow key={item.field.id} field={item.field} value={item.value} />
          ))}
        </div>
      )}

      {generalFields.map((item) => (
        <FieldRow key={item.field.id} field={item.field} value={item.value} />
      ))}

      {log?.comment && (
        <>
          <div className={s.comment__title}>
            <Notes />
            <span>Комментарий</span>
          </div>
          <div className={s.comment__value}>
            <pre>{log.comment}</pre>
          </div>
        </>
      )}

      <TaskDescriptionSection task={task} loadingStage={loadingStage} />
    </>
  );
};
